import dams from './dams'
import waterTreatmentPlants from './water-treatment-plants'
import groundwater from './groundwater'
import wasteWaterTreatmentPlants from './waste-water-treatment-plants'
import surface from './surface'
import utilities from './utilities'
import reservoirs from './reservoirs'
import wells from './wells'
import carriers from './carriers'

export default {
  surface,
  groundwater,
  utilities,
  'water-treatment-plants': waterTreatmentPlants,
  'waste-water-treatment-plants': wasteWaterTreatmentPlants,
  dams,
  reservoirs,
  wells,
  carriers
}
